import { render } from "./PokemonInfo.vue?vue&type=template&id=1741e90c"
import script from "./PokemonInfo.vue?vue&type=script&lang=js"
export * from "./PokemonInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/diavolo/Projects/yachay/pokemon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__